import gql from 'graphql-tag'
import { productRequired, productMain, options, properties, lists, ingredients, ingredientsGeneral, intervals, concepts, restaurant, /*productCategory, productSetCategory, gridProductsSet*/
	categoriesProperties } from '../fragments'

const query = gql`
query getProduct($id: ID!) {
	cashAssist {
		getProduct(id: $id) {
			...productRequired
			...productmain
			...options

			img {
				uid
				key
			}
			categoryId
			imgKiosk {
				uid
				key
			}
			specialPrices {
				id
				type
				typeName
				fromDate
				toDate
				name
				price
				priceInCafe
			}
			...properties
			cashRegisterId
			category {
				id
				name
			}
			...lists
			...intervals
			isWeighted
			isTareInLabelMode
			tare
			EANCode
			# EANstatistics
			cardChargeAmount
			cardSurchargePercent
			cardSurchargeFrom
			discount
			points {
				type
				quantity
				points
			}
			pointsCost
			pointsPriceLevel
			isInventory
			inventoryUnit
			minOrder
			numberPerUnit
			nameInOrder
			canCopy
			orderUnit
			visibleStatus
			bakeryReturn
			bakeryReturnEndOfDay
			bakeryStock
			FA_ProductId
			shopId
			isMenuName
		}
	}
}
${productRequired}
${productMain}
${options}
${properties}
${lists}
${intervals}`

export const getProduct_Sets = gql`
query getProduct_Sets($id: ID!) {
	cashAssist {
		getProduct(id: $id) {
			...productRequired
			sets {
				category {
					id
					name
					gridProducts {
						productId
						product {
							id
							code
							name
						}
					}
				}
				minQuantity
				maxQuantity
				priceLevel
				isCollectPoints
				weekDays
				course
				fixProducts {
					code
					amount
					price
				}
			}
			properties {
				isMenuQuickAdd
			}
			priceDiffMode
			setsMode
			# printChosenSubProductsFlag
			fixProductsAutoSelect
			isPricesNormalByDefaultInSet
			isMenuName
			# isFastSelection
			# endregion isForTasting
			# printChosenSubProducts
		}
	}
}
${productRequired}`

export const getProduct_Ingrs = gql`
query getProduct_Ingrs($id: ID!) {
	cashAssist {
		getProduct(id: $id) {
			...productRequired
			...ingredientsGeneral
			...ingredients
			...categoriesProperties
			linkProduct {
				id
				name
				...ingredients
			}
		}
	}
}
${productRequired}
${ingredients}
${ingredientsGeneral}
${categoriesProperties}
`

export const getProduct_Concepts = gql`
query getProduct_Concepts($id: ID!) {
	cashAssist {
		getProduct(id: $id) {
			...productRequired
			...concepts
		}
	}
}
${productRequired}
${concepts}
`

export const getProduct_Restaurant = gql`
query getProduct_Restaurant($id: ID!) {
	cashAssist {
		getProduct(id: $id) {
			...productRequired
			...restaurant
			properties {
#				KitchenReportOnlyOverMenu
				isOnlySelfCheckoutPrintKitchenInfo
				isOnlySelfChckoutPagerRequest
			}
		}
	}
}
${productRequired}
${restaurant}
`

export default query
